import {
    CREATE_TRANSACTION_STATUS
} from "../action";
import {transactionStatus} from "./initial-store";

const initialState = transactionStatus;

function transactionStatusReducer(state = initialState, action) {
    let newState;
    switch (action.type) {
        case CREATE_TRANSACTION_STATUS:
            newState = action.payload;
            return newState;

        default:
            return state;
    }
}

export default transactionStatusReducer;